import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import CheckboxField from '../../FormLegacy/FormFieldsV2/CheckboxField'
import RadioField from '../../FormLegacy/FormFieldsV2/RadioField'
import SelectField from '../../FormLegacy/FormFieldsV2/SelectField'
import TextField from '../../FormLegacy/FormFieldsV2/TextField'
import Icon from '../../Icons'
import { getDiscountTypes } from '../helpers'

const ModifyPrice = ({
  userRole,
  modifyPriceMethod,
  isLoading,
  prefferedPriceOrDiscount,
  discountType,
  setModifyPriceMethod,
  onChangePrefferedPriceOrDiscount,
  setDiscountType,
}) => {
  const { t } = useTranslation(['payment'])
  const discountTypes = getDiscountTypes(t)

  const handleModifyPriceMethod = () => {
    if (modifyPriceMethod) {
      setModifyPriceMethod(null)
    } else {
      setModifyPriceMethod('customPrice')
    }
  }

  if (userRole !== 'Administrator') return null
  return (
    <React.Fragment>
      <CheckboxField
        name="modifyPrice"
        label={t('payment:modifyPrice.toggleLabel')}
        value={!!modifyPriceMethod}
        onChange={handleModifyPriceMethod}
        disabled={isLoading}
      />
      {modifyPriceMethod && (
        <React.Fragment>
          <div className="modify-price-selectors">
            <RadioField
              name="customPrice"
              value={'push'}
              checked={modifyPriceMethod === 'customPrice'}
              label={t('payment:modifyPrice.customPrice')}
              onChange={() => setModifyPriceMethod('customPrice')}
              disabled={!modifyPriceMethod || isLoading}
            />
            <RadioField
              name="discount"
              value={'push'}
              checked={modifyPriceMethod === 'discount'}
              label={t('payment:discount')}
              onChange={() => setModifyPriceMethod('discount')}
              disabled={!modifyPriceMethod || isLoading}
            />
          </div>
          <div className="flex-row">
            <TextField
              maxLength="10"
              name="prefferedPriceOrDiscount"
              label={
                modifyPriceMethod === 'customPrice'
                  ? t('payment:modifyPrice.enterPreferredPrice')
                  : t('payment:modifyPrice.enterPreferredDiscount')
              }
              placeholder="0"
              onChange={(e) => onChangePrefferedPriceOrDiscount(e.target.value)}
              value={prefferedPriceOrDiscount}
              leftIcon={
                modifyPriceMethod === 'customPrice' ? (
                  <Icon
                    icon="dollar"
                    fill="none"
                    svgProps={{
                      stroke: '#3C3C3C',
                      strokeLinecap: 'round',
                      strokeLinejoin: 'round',
                    }}
                  />
                ) : null
              }
              style={{ marginTop: 5 }}
              type="number"
              disabled={isLoading}
            />
            {modifyPriceMethod === 'discount' && (
              <SelectField
                name={'discountType'}
                value={discountType}
                options={discountTypes}
                onChange={(e) => setDiscountType(e.target.value)}
                disabled={isLoading}
              />
            )}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

ModifyPrice.propTypes = {
  userRole: PropTypes.string,
  modifyPriceMethod: PropTypes.string,
  isLoading: PropTypes.bool,
  prefferedPriceOrDiscount: PropTypes.string,
  discountType: PropTypes.string,
  setModifyPriceMethod: PropTypes.func,
  onChangePrefferedPriceOrDiscount: PropTypes.func,
  setDiscountType: PropTypes.func,
}

export default ModifyPrice
